import { useState } from "react";
import styles from "../TableFilterTemplate/TableFilterTemplate.module.css";
import TableTemplate from "../TableTemplate/TableTemplate";

interface TableFilterTemplateProps {
  sortStateField?: string;
  loadData: any;
  saveData?: any;
  createData?: any;
  deleteData?: any;
  title?: string;
  fields: any[];
}

export default function TableFilterTemplate(props: TableFilterTemplateProps) {
  const [topFilters, setTopFilters] = useState<Record<string, string>>({});

  return (
    <>
      <div className={styles.topFilters}>
        {props.fields.map(f => (
          <input
            key={f.name}
            placeholder={f.name}
            className={styles.filterInput}
            value={topFilters[f.name] || ""}
            onChange={e =>
              setTopFilters(prev => ({ ...prev, [f.name]: e.target.value }))
            }
          />
        ))}
      </div>

      <TableTemplate
        loadData={props.loadData}
        saveData={props.saveData}
        createData={props.createData}
        deleteData={props.deleteData}
        title={props.title}
        fields={props.fields}
        sortStateField={props.sortStateField}
        externalFilters={topFilters}
      />
    </>
  );
}